// Shared Material Symbol names — single source of truth so the same concept
// renders with the same icon everywhere (sidebar, badges, headers, …).

export const ALERT_ICON = 'notifications_active';

// Product module icons, as shown for each module in SidebarMain.
export const MODULE_ICONS = {
    kyx: 'fact_check',
    kyt: 'currency_exchange',
    pulse: 'monitor_heart',
} as const;

// Risk/monitoring concept icons — one per concept, shared by the monitoring config, Pulse and the
// KYC dossier so e.g. PEP or sanctions look the same on every screen.
export const CONCEPT_ICONS = {
    pep: 'account_balance',
    sanctionsNational: 'flag',
    sanctionsInternational: 'public',
    lawsuits: 'gavel',
    fiscal: 'receipt_long',
    labor: 'work',
    negativeMedia: 'newspaper',
} as const;
